
import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectWishlist$ = new BehaviorSubject({});

export const behaviorSubjectWishlist = behaviorSubjectWishlist$.asObservable();